var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-card',{attrs:{"title":"Async Tree","code-toggler":""}},[_c('v-tree',{ref:"tree",attrs:{"data":_vm.treeData,"multiple":false},on:{"node-check":_vm.nodechecked,"async-load-nodes":_vm.asyncLoad}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }